<main class="main users chart-page card card-body" id="skip-target">
    <div class="container-fluid cardone">
        <!-- <p class="stat-cards-info__title title">Excursion</p> -->
      <h2 class="main-title">Daily Report</h2>
      <form [formGroup]="reportForm" (ngSubmit)="report_serarch_FormSubmit()">
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name">Display Type</label>
                </div>
                <div class="col-12 ">
                  <ng-select #ngSelect formControlName="displaytype">
                    <ng-option *ngFor="let st of display_type" [value]="st.id">{{st.value}}</ng-option>
                 </ng-select>
                  <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
                </div>
              </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name">Excursion Date:</label>
            </div>
            <div class="col-12 ">
              
              <p-calendar [readonlyInput]="true"  [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" dateFormat="dd-m-yy" formControlName="excdate" ></p-calendar>
              <!-- <input type="text" formControlName="name" id="name" class="form-input" placeholder="Name" required > -->
            </div>
          </div>
         
           <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name">Status</label>
            </div>
            <div class="col-12 ">
              <ng-select formControlName="status">
                <ng-option *ngFor="let st of statuslist" [value]="st.id">{{st.value}}</ng-option>
             </ng-select>
              <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
            </div>
          </div>
         
          
          <div class="col-lg-1 col-md-1 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name"><br></label>
            </div>
            <div class="col-12 ">
              <button type="submit" class="primary-default-btn">Search</button>
              <!-- <input type="button" formControlName="name" id="name" class="form-btn" placeholder="Name" required > -->
            </div>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name"><br></label>
            </div>
            <div class="col-12 ">
              <button type="button" (click)="this.reportForm.reset()" style="background-color: #9e9e9e" class="primary-default-btn">Reset</button>
            </div>
          </div>
          
          <!-- <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name"><br></label>
            </div>
            <div class="col-12 ">
              <button type="button" style="background-color: #9e9e9e" class="primary-default-btn">Reset</button>
            </div>
          </div> -->
        </div>
        
        <div class="row">
        <br>
        </div>
        </form>
        <div class="row cardone">
            <div style="width: 100%;" class="card table-responsive">
                <p-table responsiveLayout="stack" [value]="reportlist['day_report']" [loading]="loading" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,25,50]" >
                    <!-- <ng-template pTemplate="caption">
                        Default
                    </ng-template> -->
                    <!-- <ng-template pTemplate="caption">
                      Scroll
                  </ng-template> -->
                  <ng-template pTemplate="caption">
                    <div class="flex">
                         <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
                        </div>
                </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr >
                            <th>REQUEST ID </th>
                            <th>EXC DATE</th>
                            <th>AGENT NAME</th>
                            <th>ADULT</th>
                            <th>CHILD</th>
                            <th>CHILD AGES</th>
                            <th>TOTAL PAX</th>
                            <!-- <th>Status</th> -->
                            <!-- <th>Amount</th>
                            <th>Suppliers</th> -->
                            <th>GUEST NAME</th>
                            <th>HOTEL</th>
                            <th>PICK-UP TIME</th>
                            <!-- <th>PICK-UP TIME</th> -->
                            <th>EXCURSION NAME</th>
                            <th>SERVICE PROVIDER</th>
                            <th>CATEGORY</th>
                            <th>EXC STATUS</th>
                            <th>Remarks</th>
                            <!-- <th>Action</th> -->
                        </tr>
                    </ng-template>
                    <ng-template   pTemplate="body" let-product let-columns="columns">
                        <tr [ngClass]="{'pink_row': product.service_status=='1'}" >
                            <td><span class="p-column-title">REQUEST ID</span>{{product.REQUESTID}}</td>
                            <td><span class="p-column-title">EXC DATE</span>{{product.EXCDATE}}</td>
                            <td><span class="p-column-title">AGENT NAME</span>{{product.AGENTNAME}}</td>
                            <td><span class="p-column-title">ADULT</span>{{product.NOOFADULTS}}</td>
                            <!-- <td><span class="p-column-title">Agent</span>{{product.agentname}}</td> -->
                            <td><span class="p-column-title">CHILD</span>{{product.NOOFCHILD}}</td>
                            <td><span class="p-column-title">CHILD AGES</span>{{product.CHILDAGES}}</td>
                            <td ><span class="p-column-title">TOTAL PAX</span>
                              
                              {{product.TOTALNOOFPAX}}</td>
                            <td><span class="p-column-title">GUEST NAME</span>{{product.GUESTNAME}}</td>
                            <td><span class="p-column-title">HOTEL</span>{{product.PICKUPLOCATION}}</td>
                            <td><span class="p-column-title">PICK-UP TIME</span>{{product.STARTTIME}}</td>
                            <td><span class="p-column-title">EXCURSION NAME</span>{{product.SERVICENAME}}</td>
                            <td><span class="p-column-title">SERVICE PROVIDER</span>{{product.SUPPLIERNAME}}</td>
                            <td><span class="p-column-title">CATEGORY</span>{{product.SHARINGPRIVATE}}</td>
                            <td><span class="p-column-title">EXC STATUS</span>{{product.EXCSTATUS}}</td>
                            <td><span class="p-column-title">Remarks</span><div>From Booking:{{product.BOOKINGREMARKS}}</div><div>From Supplier:{{product.FROMSUPPLIER}}</div>To supplier:{{product.TOSUPPLIER}}</td>
                            <!-- <td><span class="p-column-title">HOTEL</span>{{product.supplier}}</td> -->
                            <!-- <td><span class="p-column-title">Action</span><button (click)="viewdetails(product)" class="primary-default-btn">View</button></td> -->
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        
        
    </div>
  </main>